const isDev = process.env.VUE_APP_API_MODE === "development";
const isUat = process.env.VUE_APP_API_MODE === "staging";
const isProd = process.env.VUE_APP_API_MODE === "production";

// console.log("generateApiURL isDev", isDev);

export function generateApiURL(apiUrl) {
  if (isProd) {
    return apiUrl;
  }

  return isDev ? `${apiUrl}-dev` : isUat ? `${apiUrl}-uat` : "";
}

export const customMixins = {
  methods: {
    generateApiURL
  }
};
